module.exports = __webpack_public_path__ + "img/bos12.01104319.webp";